import React from 'react'
import './loader.css'

function Loader() {
  return (
    <div className='conatiner-fluid'>
        <div className='loader'>
        <div className='row'>
            <div className='col-md-12'>
            <div class="lds-ripple"><div></div><div></div></div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default Loader
